import API from "./api";
import { Clinician_API_URLS } from "./constants";
export function getClinicianProfileApi(clinicianUri) {
  return API.post(Clinician_API_URLS.getClinicianProfile, clinicianUri);
}
